const xl = 4;
const lg = 4;
const md = 6;
const sm = 12;
const xs = 12;

export { xl, lg, md, sm, xs };
